// login apis
export const SIGNUP_API = '/SignupKitchen';
export const LOGIN_API = '/LoginKitchen';
export const LOGOUT_API = '/KitchenLogout';
export const VERIFY_OTP_API = '/OtpKitchenEmailVerify';
export const FORGOT_PASSWORD_API = '/KitchenForgotPassword';
export const RESET_PASSWORD_API = '/KitchenResetPassword';
export const UPDATE_KITCHEN_OPERATION = '/UpdateKitchenOperation';
export const ADD_DEDICATED_DRIVER = '/addDedicatedDriver';
export const GET_ORDERS_API = '/GetKitchenOrders';
export const UPDATE_ORDER_STATUS = '/UpdateOrderStatus';

export const GET_SERVING_ZIPCODE_ADMIN_API = '/GetServingZipcodeForAdmin';
export const FUTURE_KITCHEN_API = '/CreateFutureKitchen';
export const ONLOAD_INFORMATION_API = '/OnLoadKitchenInformation';
export const KITCHEN_MANAGE_DELIVERIES = '/Kitchen-Manage-Deliveries';
export const GETPRODUCT_KITCHEN = '/GetProduct-kitchen';
export const ADD_PRODUCT = '/AddProduct';

export const GET_PRODUCT_CATEGORIES = '/GetProductCategory'; // NEW ADDED ARSLAN TAKE THIS PATH

export const DELETE_PRODUCT = '/DeleteProduct';
export const UPLOAD_IMAGE_CLOUDINARY = '/UploadFileCloudinary';

export const UPDATE_PRODUCT = '/UpdateProduct';
export const UPDATE_PRODUCT_MERCHANT_STATUS = '/UpdateProductStatusMerchant';

export const OPEN_AI_PRODUCT_NAME = '/AiProductName';
export const OPEN_AI_PRODUCT_DESCRIPTION = '/AiProductDescription';
export const AI_IMAGE_GENERATOR_API = '/AiImageGenerator';
export const GET_REVENUE_SHARING = '/GetRevenueSharingData';
export const GA_ANALYTIC_REPORT = '/CustomerAnalytics';
export const ADD_MERCHANT_DOCUMENT = 'AddMerchantDocuments';
export const UPLOAD_MERCHANT_DOCUMENT_CLOUDINARY = '/UploadMerchantDocumentImage';
export const UPDATE_MERCHANT_DOCUMENT = '/UpdateMerchantDocument';
export const GET_MERCHANT_DOCUMENT = '/GetMerchantDocuments';
export const PHONE_VERIFICATION_SMS = '/OtpKitchenPhoneVerify';
export const TEMPORARY_PHONE_VERIFICATION_SMS = '/OtpTemporaryPhoneVerify';
export const MERCHANT_CONTACT_REQUEST = '/MerchantContactRequest';
export const MARKETING_AVAILABLE_TIME_SLOTS = '/MarketingAvailableTimeSlots';
export const ONBOARD_MERCHANT = '/OnboardMerchant';
export const REPORT_UI_BUG_API = '/ReportUiBugMerchant';
